import React from "react";

export default () => {

    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.8976 9.39751L12.3976 16.8975C12.2922 17.0028 12.1492 17.062 12.0001 17.062C11.8511 17.062 11.7081 17.0028 11.6026 16.8975L4.10263 9.39751C4.00327 9.29088 3.94918 9.14984 3.95175 9.00412C3.95432 8.85839 4.01335 8.71935 4.11641 8.61629C4.21947 8.51323 4.35851 8.4542 4.50424 8.45163C4.64996 8.44905 4.791 8.50315 4.89763 8.60251L12.0001 15.7041L19.1026 8.60251C19.2093 8.50315 19.3503 8.44905 19.496 8.45163C19.6417 8.4542 19.7808 8.51323 19.8838 8.61629C19.9869 8.71935 20.0459 8.85839 20.0485 9.00412C20.0511 9.14984 19.997 9.29088 19.8976 9.39751Z" fill="#1A1A1A"/>
    </svg>;


}
